/**
 * Product Size Chart Functionality
 * Shared between main-product.liquid and main-product-form.liquid
 */
(function() {
  'use strict';

  function initSizeChart() {
    const sizeBtn = document.querySelector("[data-open-table]");
    const sizePopup = document.querySelector(".size-chart-popup");
    if (!sizeBtn || !sizePopup) return;

    const sizePopupContent = sizePopup.querySelector(".size-chart-content");
    const sizeClosePopup = sizePopup.querySelector(".size-chart-close");
    let isOpening = true;

    const toggleSizeChart = () => {
      if (isOpening) {
        document.body.style.overflow = "hidden";
        sizePopup.classList.add("open");
        isOpening = false;
      } else {
        document.body.style.overflow = "";
        sizePopup.classList.remove("open");
        isOpening = true;
      }
    };

    sizeBtn.addEventListener('click', toggleSizeChart);
    sizePopup.addEventListener('click', (e) => {
      if (!sizePopupContent.contains(e.target) && sizePopupContent !== e.target && !isOpening) {
        toggleSizeChart();
      }
    });

    if (sizeClosePopup) {
      sizeClosePopup.addEventListener("click", toggleSizeChart);
    }

    document.addEventListener("keydown", (e) => {
      if (e.key === 'Escape' && !isOpening) toggleSizeChart();
    });
  }

  // Auto-initialize
  document.addEventListener('DOMContentLoaded', function() {
    initSizeChart();
  });

  // Export for manual initialization
  window.initSizeChart = initSizeChart;
})();



